<template>
  <div class="homework-drill-report" v-if="reportResult">
    <h5 v-if="error">{{ error }}</h5>
    <div class="frozen" v-else-if="ossFileFrozen">
      <div class="spinner" v-loading="ossFileFrozen"></div>
      <div>视频长时间未播放，正在查找恢复中</div>
      <div>可能需要几分钟的时间</div>
    </div>
    <video v-else controlsList="nodownload" controls :src="videoSrc" @error="errorHandle" />
    <div class="user">
      <el-avatar :src="reportResult.data.user_info.head_img_url" />
      <div class="user-info-box">
        {{ reportResult.data.user_info.nick_name }}
        <span @click="openIllegalVideoProcessDialog" v-if="rankDownErrorPermissions && showIllegalBtn">
          <img :src="warningIcon" />
          违规处理
        </span>

        <el-button
          v-if="showRankDownBtn && rankDownErrorPermissions"
          size="mini"
          class="del-video-btn"
          @click="openRankDownOfDrillDialogVisible"
        >
          下榜
        </el-button>
      </div>
      <p class="desc light">
        {{ reportResult.showTime }} <span>完成了{{ reportResult.drillName }}，成绩{{ reportResult.score }}</span>
      </p>
    </div>

    <div class="competition-title" v-if="isCompetitionType">比赛成绩</div>

    <div class="info light" :class="{ competition: isCompetitionType }">
      <div class="item" v-for="item in reportResult.competitionDrillInfo" :key="item.label">
        {{ item.label }}<span>{{ item.val }}</span>
      </div>
    </div>
    <el-divider v-if="isCompetitionType"></el-divider>
    <div class="competition-title" v-if="isCompetitionType">参赛信息</div>

    <div class="info light competition" v-if="isCompetitionType">
      <div class="competition-item item">
        比赛排名： <span>{{ competitionInfo.rank }}</span>
      </div>
      <div class="item competition-item">
        参赛分组： <span>{{ competitionInfo.group }}</span>
      </div>
      <div class="item competition-item">
        比赛项目：<span>{{ competitionInfo.drill_name }}</span>
      </div>
      <div class="item competition-item">
        参赛单位：<span>{{ competitionInfo.school }}</span>
      </div>
    </div>
    <el-dialog
      :visible.sync="illegalVideoProcessDialogVisible"
      title="视频内容违规处理"
      align="center"
      width="584px"
      :close-on-click-modal="false"
    >
      <el-form :model="illegalVideoReasonForm" :rules="rules" ref="illegalVideoFormRef">
        <el-form-item prop="reason" label="违规原因">
          <el-select v-model="illegalVideoReasonForm.reason" placeholder="请选择违规原因" clearable>
            <el-option v-for="reason in illegalVideoReasons" :key="reason" :value="reason" :label="reason"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span class="tip">为避免潜在的不良影响，我们将即刻删除该违规视频</span>
      <div class="operation-box">
        <el-button @click="illegalVideoProcessDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="deleteIllegalVideo">确认</el-button>
      </div>
    </el-dialog>
    <competition-of-drill-type-remove-dialog
      :visible.sync="rankDownOfDrillDialogVisible"
      @submit="handleRankDownSubmit"
      @cancel="handleRankDownCancel"
    ></competition-of-drill-type-remove-dialog>
  </div>
</template>
<script lang="ts">
import { BaseComponent, Component, Prop, Watch, Emit } from 'kuaidong-component'
import { AUser, AHomework } from 'kuaidong-api'
import { HttpUtil } from 'kuaidong-lib'
import { DrillReportResult } from 'kuaidong-service'
import warningIcon from '@/assets/images/img_warning@2x.png'
import CompetitionOfDrillTypeRemoveDialog from '@/components/CompetitionOfDrillTypeRemoveDialog.vue'

type Report = {
  source: string
  error: string
  user: { avatar: string; name: string }
  drill: { name: string; score: number | string; date: string }
  info: { label: string; val: string | number }[]
}

@Component({ components: { CompetitionOfDrillTypeRemoveDialog } })
export default class DrillReport extends BaseComponent {
  @Prop(String)
  id!: string

  @Prop({ type: Boolean, default: false })
  isHidePrivateVideo!: boolean

  @Prop({ type: Boolean, default: true })
  showIllegalBtn?: boolean

  @Prop({ type: Boolean, default: false })
  showRankDownBtn?: boolean

  @Prop({ type: Boolean, default: false })
  useNonTokenRequest?: boolean

  @Prop({ type: String })
  userId?: string

  @Prop({ type: String })
  groupId?: string

  @Prop({ type: Object })
  competitionInfo?: {
    rank: number
    group: string
    drill_name: string
    school: string
  }

  @Prop({ type: String })
  competitionType?: 'school' | 'onlineGame' | 'others' | 'area'

  rankDownOfDrillDialogVisible = false

  warningIcon = warningIcon
  illegalVideoProcessDialogVisible = false
  illegalVideoReasonForm = {
    reason: '',
  }
  rules = {
    reason: {
      required: true,
      message: '原因不能为空',
      trigger: 'change',
    },
  }

  hasPlayed = false
  ossFileFrozen = false
  maxFetchTime = -1 // 最对尝试次数， 目前不重新尝试
  currentFetchTime = 0
  fetchVideoUrlIntervalId: any = 0
  reportResult: DrillReportResult | null = null
  videoUrl: string | null = null

  get isCompetitionType() {
    return this.competitionInfo !== undefined
  }
  get illegalVideoFormRef() {
    return this.$refs['illegalVideoFormRef'] as any
  }

  get videoSrc() {
    // return 'https://crazyrope-video.oss-cn-shanghai.aliyuncs.com/video/22631464/20220509/high_knees_clapping_2109/B7D33A82-8E9E-49B3-B586-92F971B7C21E.mp4'
    // return 'https://crazyrope-video.oss-cn-shanghai.aliyuncs.com/video_dev/12800019/20200923/jump_rope_landscape_2007/cb2372d1-b75e-4a30-aa33-0e5c42823aa9.mp4'
    return this.reportResult && this.reportResult.videoUrl
  }

  get error() {
    if (!this.videoSrc) {
      return '视频生成加载中 ...'
    }

    if (this.reportResult?.data.is_deleted || this.reportResult?.data.rank_authority === 'close_video') {
      return '视频未开启或已删除'
    } else if (this.reportResult?.data.rank_authority === 'private' && this.isHidePrivateVideo) {
      return '视频将在用户开启权限并公开本次记录后显示'
    }

    return ''
  }

  get rankDownErrorPermissions() {
    return this.error === '' || this.error === '视频生成加载中 ...'
  }

  @Watch('id', { immediate: true })
  async onIDChanged(id: string) {
    if (!id) return (this.reportResult = null)
    this.currentFetchTime = 0
    this.ossFileFrozen = false
    this.stopFetchReportLoop()
    await this.fetchReportInfo()
    if (
      this.reportResult &&
      !this.reportResult.hasClosedVideo &&
      !this.videoSrc &&
      this.currentFetchTime <= this.maxFetchTime
    ) {
      await this.startFetchReportLoop()
    }
  }

  illegalVideoReasons = ['违反相关政策规定的内容', '涉及个人信息的隐私内容', '可能令人反感的不当内容', '其他违规原因']
  openIllegalVideoProcessDialog() {
    this.illegalVideoProcessDialogVisible = true
  }

  deleteIllegalVideo() {
    this.illegalVideoFormRef.validate(async (valid: boolean) => {
      if (valid) {
        try {
          await AHomework.deleteIllegalRecordVideo(this.id, this.illegalVideoReasonForm.reason)
          this.$message.success('视频删除成功！')
          this.$emit('deleteVideo')
        } catch (e) {
          // console.log(e)
        } finally {
          this.illegalVideoProcessDialogVisible = false
        }
      }
    })
  }

  openRankDownOfDrillDialogVisible() {
    this.rankDownOfDrillDialogVisible = true
  }

  @Emit('rankDown')
  handleRankDownSubmit(reason: string) {
    this.rankDownOfDrillDialogVisible = false
    if (this.competitionType === 'school' || this.competitionType === 'area') {
      return this.id
    } else {
      return {
        userId: this.userId,
        groupId: this.groupId,
        reason: reason,
      }
    }
  }

  handleRankDownCancel() {
    this.rankDownOfDrillDialogVisible = false
  }

  async errorHandle(err: Event) {
    if (err && err.target) {
      try {
        await HttpUtil.basicGet(this.videoSrc! + '?from=ossFrozen', {}, {}, false)
        this.ossFileFrozen = false
      } catch (e) {
        if (e && e.response && e.response.status === 403 && e.response.data.includes('InvalidObjectState')) {
          this.ossFileFrozen = true
          if (this.currentFetchTime === 0) {
            // 触发解锁
            await this.reportResult!.ossFrozenUnlock()
          }
          if (this.currentFetchTime < 5) {
            setTimeout(async () => {
              this.currentFetchTime++
              this.ossFileFrozen = false
              await this.fetchReportInfo()
            }, 60000)
          }
        } else {
          this.ossFileFrozen = false
        }
      }
    }
  }

  async fetchReportInfo() {
    let report

    // 临时修复：比赛举办者（机构账号）登录时会往这个接口默认带一个特殊 token，
    // 导致请求返回 invalid token content。useNonTokenRequest 为 true 时不带该 token，
    // 直接用 HttpUtil.get 请求原始地址，避免串入机构 token。
    if (this.useNonTokenRequest) {
      report = await HttpUtil.get(process.env.VUE_APP_CRAZYROPE_API + '/user/drill_report_info', {
        drill_record_id: this.id,
      })
    } else {
      report = await AUser.getDrillReport(this.id)
    }

    if (JSON.stringify(report) === '{}') return (this.reportResult = null)
    this.reportResult = new DrillReportResult(this.id, report)
  }

  async startFetchReportLoop() {
    this.fetchVideoUrlIntervalId = setInterval(async () => {
      if (!this.reportResult?.hasClosedVideo && !this.videoSrc && this.currentFetchTime <= this.maxFetchTime) {
        this.currentFetchTime++
        await this.fetchReportInfo()
      } else {
        this.stopFetchReportLoop()
      }
    }, 5000)
  }

  stopFetchReportLoop() {
    if (this.fetchVideoUrlIntervalId) {
      clearInterval(this.fetchVideoUrlIntervalId)
    }
  }

  beforeDestroy() {
    this.stopFetchReportLoop()
  }
}
</script>
<style lang="less">
.homework-drill-report {
  .frozen {
    text-align: center;
    padding: 50px 0;
    color: #939599;
    .spinner {
      width: 28px;
      margin: 0 auto;
      margin-bottom: 20px;
    }
  }

  video {
    width: 100%;
    max-height: 470px;
  }
  h5 {
    text-align: center;
  }
  .user {
    margin-top: 24px;
    .el-avatar {
      float: left;
      margin-right: 12px;
    }
    .user-info-box {
      font-weight: 500;
      font-size: 18px;
      line-height: 26px;
      color: #0a1629;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 8px;
      span {
        display: flex;
        justify-content: space-between;
        align-items: center;
        user-select: none;
        img {
          width: 14px;
          height: 14px;
          margin: 0px 4px;
        }
        font-weight: 500;
        font-size: 12px;
        line-height: 18px;
        color: var(--shs-theme-primary);
        &:hover {
          cursor: pointer;
        }
      }
      .del-video-btn {
        span {
          color: #6c737f;
        }
      }
    }
    p span {
      float: right;
    }
  }
  .competition-title {
    font-weight: 500;
    font-size: 18px;
    line-height: 26px;
    color: #0a1629;
    margin-top: 32px;
  }
  .info {
    margin-top: 24px;
    display: flex;
    flex-wrap: wrap;
    .item {
      width: 33%;
      margin-bottom: 20px;
      span {
        font-size: 22px;
        color: #0a1629;
      }
    }

    &.competition {
      display: flex;
      flex-wrap: wrap;
      .item {
        display: flex;
        flex-shrink: 0;
        span {
          font-weight: 400;
          font-size: 14px;
          line-height: 20px;
          color: #0a1629;
          flex-grow: 0;
          flex-shrink: 0;
        }
        &.competition-item {
          &:nth-child(1),
          &:nth-child(2) {
            width: 50%;
          }
          &:nth-child(3),
          &:nth-child(4) {
            width: 100%;
          }
        }
      }
    }
  }
  .el-dialog {
    .el-form-item {
      width: 475px;
      .el-select {
        width: 352px;
      }
    }
    .tip {
      font-weight: 500;
      font-size: 13px;
      line-height: 20px;
      color: #9da2a9;
      margin-left: 22px;
    }
    .operation-box {
      margin-top: 40px;
      .el-button {
        width: 135px;
      }
    }
  }
}
</style>
